import { render, staticRenderFns } from "./MainBookCompCardHeader.vue?vue&type=template&id=b9db3e76"
import script from "./MainBookCompCardHeader.vue?vue&type=script&lang=js"
export * from "./MainBookCompCardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports